// import { useState, useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import { Menu, X, ChevronDown } from "lucide-react";
// import logo from "../assets/logo.jpeg";

// const mainLinks = [
//   { to: "/", label: "Home" },
//   { to: "/about", label: "About" },
//   {
//     label: "Energy",
//     children: [
//       { to: "/wind-energy", label: "Wind Energy" },
//       { to: "/solar-energy", label: "Solar Energy" },
//     ],
//   },
//   { to: "/how-it-works", label: "How It Works" },
//   { to: "/packages", label: "Packages" },
//   {
//     label: "Partners",
//     children: [
//       { to: "/affiliate", label: "Affiliate Network" },
//       { to: "/targets", label: "Targets & Rewards" },
//       { to: "/dashboard-preview", label: "Dashboard Preview" },
//       { to: "/wallet", label: "Wallet & Payout" },
//     ],
//   },
//   { to: "/community", label: "Community" },
//   { to: "/faq", label: "FAQ" },
//   { to: "/contact", label: "Contact" },
// ];

// const Navbar = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(null);
//   const location = useLocation();

//   useEffect(() => {
//     const onScroll = () => setScrolled(window.scrollY > 20);
//     window.addEventListener("scroll", onScroll);
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   useEffect(() => {
//     setMobileOpen(false);
//     setDropdownOpen(null);
//   }, [location]);

//   return (
//     <motion.nav
//       initial={{ y: -100 }}
//       animate={{ y: 0 }}
//       transition={{ duration: 0.5 }}
//       className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
//         scrolled ? "bg-background/80 backdrop-blur-xl border-b border-border shadow-[0_4px_30px_hsl(220_45%_6%/0.5)]" : "bg-transparent"
//       }`}
//     >
//       <div className="container mx-auto flex items-center justify-between py-3 px-4 lg:py-3.5">
//         <Link to="/" className="flex items-center gap-3 group">
//           {/* Fixed Logo - Removed fixed width/height and made it responsive */}
//           <img
//             src={logo}
//             alt="AeroVolt"
//             className="h-10 w-auto md:h-20 lg:h-20 rounded-lg object-contain group-hover:scale-105 transition-transform duration-300"
//           />
//           {/* Optional: Add text logo if you want */}
//           {/* <span className="text-xl font-bold text-foreground">AeroVolt</span> */}
//         </Link>

//         {/* Desktop */}
//         <div className="hidden lg:flex items-center gap-0.5">
//           {mainLinks.map((link, i) =>
//             link.children ? (
//               <div key={i} className="relative" onMouseEnter={() => setDropdownOpen(link.label)} onMouseLeave={() => setDropdownOpen(null)}>
//                 <button className="flex items-center gap-1 px-3 py-2 text-sm font-medium rounded-lg text-muted-foreground hover:text-foreground transition-colors">
//                   {link.label} <ChevronDown className="w-3 h-3" />
//                 </button>
//                 <AnimatePresence>
//                   {dropdownOpen === link.label && (
//                     <motion.div
//                       initial={{ opacity: 0, y: 8 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       exit={{ opacity: 0, y: 8 }}
//                       className="absolute top-full left-0 mt-1 w-48 py-2 rounded-xl glass-card border border-border shadow-xl"
//                     >
//                       {link.children.map((child) => (
//                         <Link key={child.to} to={child.to} className={`block px-4 py-2.5 text-sm transition-colors ${location.pathname === child.to ? "text-primary bg-primary/5" : "text-muted-foreground hover:text-foreground hover:bg-secondary/50"}`}>
//                           {child.label}
//                         </Link>
//                       ))}
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </div>
//             ) : (
//               <Link
//                 key={link.to}
//                 to={link.to}
//                 className={`px-3 py-2 text-sm font-medium rounded-lg transition-all duration-300 ${
//                   location.pathname === link.to ? "text-primary bg-primary/10" : "text-muted-foreground hover:text-foreground hover:bg-secondary/50"
//                 }`}
//               >
//                 {link.label}
//               </Link>
//             )
//           )}
//           <div className="ml-3 flex items-center gap-2">
//             <Link
//               to="/login"
//               className="px-4 py-2.5 text-sm font-semibold rounded-lg border border-border text-foreground hover:bg-secondary/50 transition"
//             >
//               Login
//             </Link>
//             <Link
//               to="/register"
//               className="px-4 py-2.5 text-sm font-semibold rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-all glow-box hover:glow-box-hover"
//             >
//               Register
//             </Link>
//           </div>
//         </div>

//         <button onClick={() => setMobileOpen(!mobileOpen)} className="lg:hidden p-2 text-foreground">
//           {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
//         </button>
//       </div>

//       <AnimatePresence>
//         {mobileOpen && (
//           <motion.div
//             initial={{ opacity: 0, height: 0 }}
//             animate={{ opacity: 1, height: "auto" }}
//             exit={{ opacity: 0, height: 0 }}
//             className="lg:hidden bg-background/95 backdrop-blur-xl border-b border-border"
//           >
//             <div className="container mx-auto px-4 py-4 flex flex-col gap-1">
//               {mainLinks.map((link, index) => {
//                 // Handle links with children
//                 if (link.children) {
//                   return link.children.map((child) => (
//                     <Link 
//                       key={child.to} 
//                       to={child.to} 
//                       className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
//                         location.pathname === child.to 
//                           ? "text-primary bg-primary/10" 
//                           : "text-muted-foreground hover:text-foreground hover:bg-secondary"
//                       }`}
//                     >
//                       {child.label}
//                     </Link>
//                   ));
//                 } 
//                 // Handle regular links
//                 else {
//                   return (
//                     <Link 
//                       key={link.to} 
//                       to={link.to} 
//                       className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
//                         location.pathname === link.to 
//                           ? "text-primary bg-primary/10" 
//                           : "text-muted-foreground hover:text-foreground hover:bg-secondary"
//                       }`}
//                     >
//                       {link.label}
//                     </Link>
//                   );
//                 }
//               })}
//               <Link to="/login" className="mt-2 px-4 py-3 rounded-lg text-sm font-semibold border border-border text-center">
//                 Login
//               </Link>
//               <Link to="/login" className="mt-2 px-4 py-3 rounded-lg text-sm font-semibold bg-primary text-primary-foreground text-center">
//                 Register
//               </Link>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </motion.nav>
//   );
// };

// export default Navbar;

import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ChevronDown } from "lucide-react";
import logo from "../assets/logo.jpeg";

const mainLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  {
    label: "Energy",
    children: [
      { to: "/wind-energy", label: "Wind Energy" },
      { to: "/solar-energy", label: "Solar Energy" },
    ],
  },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/packages", label: "Packages" },
  // {
  //   label: "Partners",
  //   children: [
  //     { to: "/affiliate", label: "Affiliate Network" },
  //     { to: "/targets", label: "Targets & Rewards" },
  //     { to: "/dashboard-preview", label: "Dashboard Preview" },
  //     { to: "/wallet", label: "Wallet & Payout" },
  //   ],
  // },
  { to: "/community", label: "Community" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setDropdownOpen(null);
  }, [location]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileOpen]);

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-background/80 backdrop-blur-xl border-b border-border shadow-[0_4px_30px_hsl(220_45%_6%/0.5)]" : "bg-transparent"
      }`}
    >
      <div className="container mx-auto flex items-center justify-between py-3 px-4 lg:py-3.5">
        <Link to="/" className="flex items-center gap-3 group">
          {/* Fixed Logo - Removed fixed width/height and made it responsive */}
          <img
            src={logo}
            alt="AeroVolt"
            className="h-10 w-auto md:h-20 lg:h-20 rounded-lg object-contain group-hover:scale-105 transition-transform duration-300"
          />
          {/* Optional: Add text logo if you want */}
          {/* <span className="text-xl font-bold text-foreground">AeroVolt</span> */}
        </Link>

        {/* Desktop */}
        <div className="hidden lg:flex items-center gap-0.5">
          {mainLinks.map((link, i) =>
            link.children ? (
              <div key={i} className="relative" onMouseEnter={() => setDropdownOpen(link.label)} onMouseLeave={() => setDropdownOpen(null)}>
                <button className="flex items-center gap-1 px-3 py-2 text-sm font-medium rounded-lg text-muted-foreground hover:text-foreground transition-colors">
                  {link.label} <ChevronDown className="w-3 h-3" />
                </button>
                <AnimatePresence>
                  {dropdownOpen === link.label && (
                    <motion.div
                      initial={{ opacity: 0, y: 8 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 8 }}
                      className="absolute top-full left-0 mt-1 w-48 py-2 rounded-xl glass-card border border-border shadow-xl"
                    >
                      {link.children.map((child) => (
                        <Link key={child.to} to={child.to} className={`block px-4 py-2.5 text-sm transition-colors ${location.pathname === child.to ? "text-primary bg-primary/5" : "text-muted-foreground hover:text-foreground hover:bg-secondary/50"}`}>
                          {child.label}
                        </Link>
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ) : (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-all duration-300 ${
                  location.pathname === link.to ? "text-primary bg-primary/10" : "text-muted-foreground hover:text-foreground hover:bg-secondary/50"
                }`}
              >
                {link.label}
              </Link>
            )
          )}
          <div className="ml-3 flex items-center gap-2">
            <Link
              to="/login"
              className="px-4 py-2.5 text-sm font-semibold rounded-lg border border-border text-foreground hover:bg-secondary/50 transition"
            >
              Login
            </Link>
            <Link
              to="/register"
              className="px-4 py-2.5 text-sm font-semibold rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-all glow-box hover:glow-box-hover"
            >
              Register
            </Link>
          </div>
        </div>

        <button onClick={() => setMobileOpen(!mobileOpen)} className="lg:hidden p-2 text-foreground">
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-background/95 backdrop-blur-xl border-b border-border"
            style={{ maxHeight: 'calc(100vh - 80px)', overflowY: 'auto' }} // Added for scrollable menu
          >
            <div className="container mx-auto px-4 py-4 flex flex-col gap-1">
              {mainLinks.map((link, index) => {
                // Handle links with children
                if (link.children) {
                  return link.children.map((child) => (
                    <Link 
                      key={child.to} 
                      to={child.to} 
                      className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                        location.pathname === child.to 
                          ? "text-primary bg-primary/10" 
                          : "text-muted-foreground hover:text-foreground hover:bg-secondary"
                      }`}
                    >
                      {child.label}
                    </Link>
                  ));
                } 
                // Handle regular links
                else {
                  return (
                    <Link 
                      key={link.to} 
                      to={link.to} 
                      className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                        location.pathname === link.to 
                          ? "text-primary bg-primary/10" 
                          : "text-muted-foreground hover:text-foreground hover:bg-secondary"
                      }`}
                    >
                      {link.label}
                    </Link>
                  );
                }
              })}
              {/* Fixed: Changed second Login to Register and added proper spacing */}
              <div className="mt-4 pt-2 border-t border-border flex flex-col gap-2">
                <Link 
                  to="/login" 
                  className="w-full px-4 py-3 rounded-lg text-sm font-semibold border border-border text-center hover:bg-secondary/50 transition"
                >
                  Login
                </Link>
                <Link 
                  to="/register" 
                  className="w-full px-4 py-3 rounded-lg text-sm font-semibold bg-primary text-primary-foreground text-center hover:bg-primary/90 transition-all glow-box"
                >
                  Register
                </Link>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;